import { useNavigate } from "react-router-dom";
import textWeight from "../../utils/textWeight";

export default () => {
  const navigate = useNavigate();
  const { TextWeight } = textWeight();
  return { navigate, TextWeight };
};
